export { default as PercentageCircle } from './component';
